<template>
    <div>
        <MdTitleRegInfo  
            v-bind:RegistrationInfo="{}"  
            v-bind:titlePrefix="'Notes Information'"            
            v-bind:titleRef="'titleElementNotes'">
        </MdTitleRegInfo>

        <p class="iSetupLabel">
            <i class="ikon med-help"></i>
            Check your favorite notes or click to display them. Once complete, hit <b>Save</b> to move forward.
        </p>

        <b-row v-if="this.ProvidersList.length > 1">           
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Provider'"
                        v-bind:Options="ProvidersList"
                        v-bind:FieldDescription="'companyName'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'providerCode'"
                        v-bind:Model="Provider"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownProviders"/>
            </b-col> 
            <b-col lg="3" md="3" sm="12" class="d-flex flex-column justify-content-end">  
                <MdButton
                    v-bind:isReadOnly="false"
                    v-bind:Label="'Apply Selection To All Providers'"
                    v-bind:Name="'btnAplySelection'"
                    v-on:click="ApplySelectAllProvider()"
                    v-bind:ClassProp="'btn-login mb-2'"/>            
            </b-col>
        </b-row>
        

        <b-row>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Selected'"
                        v-bind:Options="StatusList"
                        v-bind:FieldDescription="'description'"
                        v-bind:IsDisabled="false"
                        v-bind:AllowEmpty="false"
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Status"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownStatus"/>
            </b-col>
            <b-col lg="3" md="3" sm="12">            
                    <MdSelect
                        v-bind:Label="'Category'"
                        v-bind:Options="CategoryList"
                        v-bind:FieldDescription="'name'"
                        v-bind:IsDisabled="false"                       
                        v-bind:FieldCode="'code'"
                        v-bind:Model="Category"                       
                        v-bind:Multiple="false"
                        :Input="ChangeDropDownCategory"/>
            </b-col>
               <b-col lg="3" md="3" sm="12">

               </b-col>
            <b-col lg="3" md="3" sm="12">
                <div class="text-center text-md-right mt-3">
                    <button 												
                        type="button"
                        v-on:click="getNotesList"
                        class="btn btn-primary btn-login mx-2 pull-right"												
                        id="btnsearchinput">
                        {{ $t('Shared.Search') }}            
                    </button>
                </div>
            </b-col>
        </b-row>
        
       <MdTitle v-bind:Text="$t('Shared.SearchResult')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

        <div class="flex-container">
              <div class="row">                
              
              <div class="col-md-3">
                 <MdCheckBox
                  v-bind:Label="$t('Shared.SelectAll')"
                  v-bind:Name="'SelectTableAll'"
                  v-bind:ClassProp="'AlignCheck mx-3'"
                  v-bind:CheckedValue="true"
                  v-bind:isReadOnly="this.items.length === 0"
                  v-bind:UncheckedValue="false"
                  v-model="UseSelectTableAll" 
                  v-on:change="onChangeSelectAll"                
               /> 
              </div>
              <div class="col-md-3 mt-3">
                <span class="tableSelectedItems"><span class="selItemsVal">{{ SelectedRecords }}</span> {{ $t('claimbatchList.item') }}<span v-if="SelectedRecords != 1">s</span> {{ $t('Shared.selected') }}</span>
              </div>  
             <div class="col-md-6">
                       <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                      <div class="input-group" dir="ltr">
                          <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="modelSearch"                          
                            @keyup.enter="FindinItems()"
                          >
                          <div class="input-group-append">
                              <MdButton 
                                v-bind:Name="'btnsearchinput'"
                                v-bind:VariantProp="'btn btn-sm search-attached'"
                                v-bind:IconClass="'mdi mdi-magnify'"                               
                                v-on:click="FindinItems"
                                 >
                              </MdButton>
                          </div>
                      </div>
                  </div>
             </div>
                  
          
                                     
              </div>
          </div>

         
        <MdTablePaginationClient 
            v-bind:fields="fields"
            v-bind:items="items"
            v-bind:totalRows="totalRows"              
            v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
            v-bind:currentPage="currentPage"
            v-bind:perPage="perPage" 
            v-bind:SelectAll="UseSelectTableAll"             
            v-bind:pageOptions="pageOptions"
            :iconSelected="IconSelected"
            :viewIconEvent="ViewNote"
            :onFiltered="onFiltered"
            :onRowSelected="onRowSelected"    
            :pageChanged="pageChanged"
            :RowClick="RowClicked"        
            :perPageFunction="PerPageFunction">                
        </MdTablePaginationClient>

     

        <div class="space-actions"></div>
        <div class="page-actions">

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'◄'"
            v-bind:Name="'btnNotesBack'"
            v-on:click="Back"
            v-bind:ClassProp="'mx-2'"/>

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="'►'"
            v-on:click="Next"
            v-bind:Name="'btnnotesNext'"
            v-bind:ClassProp="'mx-2'"/>  

        <MdButton
            v-bind:isReadOnly="false"
            v-bind:Label="$t('Shared.Save')"
            v-bind:Name="'btnNotes'"
            v-on:click="UpdateSelectedNoteSetup"
            v-bind:ClassProp="'mx-2 btn-login'"/>
        </div>

       <IniModalSetupNote
            v-if="showModalNote"
            v-bind:NoteId="FormId"
            v-bind:Header="Header"
            v-bind:CategoryCode="CategoryCode"
            v-bind:TitleWindow="'Note design '+TitleNote" 
            @onSelectSetupNote="SelectNote"
            @onCloseSetupNote="CloseNote"
            @getCodeConditionOK="OnReturnNoteOK($event)"
            @getCodeConditionCANCEL="OnReturnNoteCancel($event)"
             v-bind:ModalId="modalIdNote">
        </IniModalSetupNote>


        <!--<IniModalEditNote
            v-if="showModalEditNote"
            v-bind:RecId="RecId"
            v-bind:Header="Header"
            v-bind:TitleWindow="'Edit Note'" 
            @OnResetModal="Reset($event)"
            @getCodeConditionOK="OnReturnEditNoteOK($event)"
            @getCodeConditionCANCEL="OnReturnEditNoteCancel($event)"
             v-bind:ModalId="'iModalEditNote'">
        </IniModalEditNote>-->

     <!--<EmployeeInboxNotesModal v-if="showModalNote"
        v-bind:Header="Header"       
        v-bind:ProgramCode="ProgramCode"
        v-bind:CategoryCode="CategoryCode"> 
      </EmployeeInboxNotesModal>-->



    </div>
   

</template>

<script>
import { EventBus } from '@/event-bus.js';
import ISetup from '@/services/isetup.service'
import DBFunctions from '@/common/DBFunctions.js';
import ShowMessage from '@/components/messages/ShowMessage.js'

export default {
  name: 'IniNotes',
   mixins: [ShowMessage, DBFunctions],
  data(){
    return{
        modalIdNote:"OpenIdNoteModal",
        showModalNote:false,
        showModalEditNote:false,
        RecId:"",
        TitleNote:"",
        CategoryCode:"",
        Header:{
          description:"",
        },
        params:{      
          NotesID: "",
          HeaderId: "", 
          PatientCode: "",
          TherapyCode: "", 
          TransDate : "",
          AdmissionRecordID: "",
          IsVoid: ""
        },
         parameter:{
            SearchCriteria:"",
          // PageNumber : 0,
           // PageSize:0,
            ProviderCode:"",
            Category:"",
            Selected:"" 
        },
        bDescription:"",        
        Status:{code:null,description:"All"},
        
        StatusList:[
           {code:null,description:"All"},
           {code:true,description:"Yes"},
           {code:false,description:"No"},           
        ],
        Category:"",
        CategoryList:[],
        ProvidersList:[],
        Provider:{providerCode:"",companyName:""},
        FormId:"",
         fields:[
            { key: 'category', sortable: true, label: 'Category', class: 'text-rigth' },
            { key: 'formId', sortable: true, label: '', class: 'text-rigth hidden' },
            { key: 'recId', sortable: true, label: '', class: 'text-rigth hidden' }, 
            { key: 'formTitle', sortable: true, label: 'Note', class: 'text-rigth' },
           
        ],
        ShowMessageIsEmpty:false,
        items:[],
        itemscopy:[],
        indexSelected : 0,
        SelectedRecords:0,
        UseSelectTableAll:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        perPage: 10,
        modelSearch:"",
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
    }
  },
  methods:{
    Next(){
        this.$router.push({ name:'iapptypes'});
    },

    Back(){
        this.$router.push({ name:'iprograms'}); 
    },

    FindNoteAndSelect(NoteId){
      this.items.forEach(element => {
          if(element.formId === NoteId){
            element.selected = true;          
          }
      });

    },

    SelectNote(NoteId){
      this.FindNoteAndSelect(NoteId);
      this.showModalNote = false;
    },

    CloseNote(){
      this.showModalNote = false;
    },

    OnReturnEditNoteOK(){
       this.showModalEditNote = false;
       this.getNotesList();
    },

    OnReturnEditNoteCancel(){
       this.showModalEditNote = false;
    },

    ChangeDropDownProviders(item){
      this.Provider = item;
      this.parameter.ProviderCode = item.providerCode;
      this.getNotesList();
    },

     Reset(){
        this.showModalEditNote = false;
       // this.getNotesList();
    },

    ChangeDropDownStatus(item){
      this.Status = item;
      this.parameter.Selected = item.code;
      this.getNotesList();
    },

    ChangeDropDownCategory(item){
      this.Category = item;
      this.parameter.Category = item ? item.code : null;
      this.getNotesList();
    },

    CompareChanged(formId,selected){    
      const record = this.itemscopy.find(item => item.formId === formId);
      let changed = record.selected !== selected;

      if(changed){
        record.selected = selected;
      }
      return changed;
    },

     getSelection(){
        let arr = [];
        this.items.forEach(element => {          
          if(this.CompareChanged(element.formId,element.selected)){
            arr.push({formId:element.formId,selected:element.selected});
           }
        });
        return arr;
    },

    async UpdateSelectedNoteSetup(){   
      this.$emit('load', true);
      await ISetup.UpdateSelectedNote(this.Provider.providerCode,this.getSelection())
      .then((response) => {      
           if (response.status == "200") { 
              this.$emit('load', false);            
           }
          this.$emit('load', false);  
      })
      .catch(error => {
        this.$emit('load', false);  
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    async getNoteDefaultHeader(row) {  
        this.$emit('load', true)
        await ISetup.GetNoteHeader(row.formId)
        .then((response) => {
          if(response.status == '200'){           
            this.Header = response.data;
            this.Header.description = row.formTitle;
            this.Header.Id = response.data.headerID;
            this.Header.admissionRecordId = response.data.admissionRecordID;
            this.Header.notesId = response.data.notesID;
            this.Header.IsVoid = response.data.isVoid;
            this.showModalNote = true;
          }
          this.$emit('load', false);      
        })
        .catch(error => {
          this.$emit('load', false);
          this.showResponseErrorMessage(error);
        });
      
    },

    //
     GetCategoriesSetupNotes(){ 
       ISetup.GetCategories()
      .then((response) => {      
           if (response.status == "200") {              
                this.CategoryList = response.data;  
           }          
      })
      .catch(error => {       
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    async getProviders(){   
      this.$emit('load', true);   
      await ISetup.getAllSetupProviders()
      .then((response) => {      
           if (response.status == "200") {              
                this.ProvidersList = response.data;
                if(this.ProvidersList.length >= 1){
                    this.Provider.providerCode = this.ProvidersList[0].providerCode;
                    this.parameter.ProviderCode = this.ProvidersList[0].providerCode;
                    this.Provider.companyName = this.ProvidersList[0].companyName;                    
                }
                this.$emit('load', false);
           }
           this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },


    ApplySelectAllProvider(){   
      this.$emit('load', true);     
      ISetup.UpdateSelectAllProvider(this.Provider.providerCode)
      .then((response) => {      
           if (response.status == "200") { 
             this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                         title: this.$t('Msg.Success'),
                          autoHideDelay: 5000,
                          variant: "success"
                        })
               this.$emit('load', false);               
           }
          this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

   async ViewNote(row){   
        this.FormId = row.formId;
        this.TitleNote = row.formTitle;
        this.CategoryCode = row.category;
         await this.getNoteDefaultHeader(row);   
       // this.showModalNote = true;
      //  console.log(row);
    },

    async Edit(row){
      this.RecId = row.recId;
        
    },

    OnReturnNoteOK(){
        this.showModalNote = false;
    },

    OnReturnNoteCancel(){
        this.showModalNote = false;
    },

    FindinItems(){ 
         this.items = this.itemscopy;
         var arr = this.items;
         var temp = [];
        if(this.modelSearch){
           arr.forEach(element => {
               if(element.category && element.category.toUpperCase().includes(this.modelSearch.toUpperCase()) ||
                element.formTitle && element.formTitle.toUpperCase().includes(this.modelSearch.toUpperCase())
                ){
                   temp.push(element);
                }
           })
        }else{
            temp = this.itemscopy;
        }

         this.items = temp;
         this.totalRows = this.items.length;
    },

    onFiltered(){

    },

    async getNotesList(){   
      this.$emit('load', true); 
      this.items = [];  
      /*let param = {
        ProviderCode:this.Provider.providerCode,
        Selected:this.Status.code,                        
        PageSize: parameter.PageSize,          
        PageNumber : parameter.PageNumber, 
      }*/
      await ISetup.getAllNotes(this.parameter)
      .then((response) => {      
           if (response.status == "200") {              
                this.items = response.data;  
                this.totalRows = this.items.length;    
                this.ShowMessageIsEmpty = this.items.length === 0 ? true : false;        
                this.$emit('load', false);               
                this.itemscopy = JSON.parse(JSON.stringify(this.items));
           }
           this.$emit('load', false);
      })
      .catch(error => {
        this.$emit('load', false);
        if (error.response) {
          this.showMessage(this.$tc('Msg.Error'),error,"error");
        }
      });  
    },

    PerPageFunction(perpage){
        this.perPage = perpage;  
        this.currentPage = 1;
      //  this.SearchAppTypes();   
    },

    pageChanged(page){
        this.currentPage = page;    
       // this.SearchAppTypes();   
    },

    IconSelected(){

    },
     onRowSelected(){ 
     this.SelectedRecords = 0;
     if(this.items.length > 0){
    for(var i = 0; i < this.items.length; i++){
      if(this.items[i].selected){
        this.SelectedRecords++;
      }
    }
     }
    },
    SelectAllRecords(){
      this.SelectedPage = this.items.length;
      this.wasSelectedAll = true;
    },
     onChangeSelectAll(v){
        if(v){
        this.SelectedRecords = this.items.length; 
        for(var i = 0 ; i < this.items.length; i++){
           this.$set(this.items[i], 'selected', true); 
        }
      }else{
        this.SelectedRecords = 0;
        for(var j= 0 ; j < this.items.length; j++){
           this.$set(this.items[j], 'selected', false); 
        }
      }
    },

    RowClicked(item,index,event){
        this.indexSelected = index;
       
     
    if(event.target.getAttribute('btn') === null){
        if(item.selected){      
          this.$set(item, 'selected', false);         
        }else{
          this.$set(item, 'selected', true);       
        }
        EventBus.$emit('rowClicked', item);
    }
        
    },
  },
  async created(){
     await this.getProviders();
     this.GetCategoriesSetupNotes();      
      this.getNotesList();
     EventBus.$on("rowClicked", function () {        
        this.SelectedRecords = 0;
            for(var i = 0; i < this.items.length; i++){
                if(this.items[i].selected){
                    this.SelectedRecords++;
                }
            }      
     }.bind(this));
  },
  mounted(){
   
  }   
};
</script>


